import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'carbon-components-react';
import { QuestionInterface } from '../../../lib/type';
import { useContext, useEffect, useState } from 'react';
import './QuestionTable.scss';
import ProgressBar from 'carbon-components-react/lib/components/ProgressBar';
import { ArrowRight20 } from '@carbon/icons-react';
import { layoutContext } from '../../LeaderAssesssment';

interface questionsProps {
  contents: QuestionInterface;
  totalOfQuestions: any;
  qNextBtn: object;
}

const QuestionTable = (questionsProps: questionsProps) => {
  const { contents, totalOfQuestions, qNextBtn } = questionsProps;
  const [headers, setHeaders] = useState(['']);
  const [rows, setRows]: any[] = useState([{ id: '' }]);
  const { degree, options } = contents;
  const [selectedValues, setSelectedValues]: any = useState({});
  const [disabled, setDisabled] = useState(true);

  const { setScore, score, currentQuestion, setCurrentQuestion } =
    useContext(layoutContext);

  useEffect(() => {
    const degrees: any[] | undefined = degree?.map(
      (d) => d.copy.props.defaultMessage,
    );
    const degreesV: any = degree?.map((d) => d.value);

    if (degrees) {
      setHeaders(['', ...degrees]);

      const rows: any = [];
      let selected: any = {};
      options.forEach((option, i) => {
        const obj = {
          id: `input${i + 1}`,
          '': option.copy.props.defaultMessage,
        };
        selected = { ...selected, [option.copy.props.defaultMessage]: null };

        degrees.forEach((degreeCopy, i) => {
          obj[degreeCopy as keyof typeof obj] = {
            option: option.copy.props.defaultMessage,
            value: degreesV[i] * option.value,
          };
        });

        rows.push(obj);
      });

      setSelectedValues(selected);
      setRows(rows);
    }
  }, []);

  useEffect(() => {
    handleDis();
  }, [selectedValues]);

  const handleChange = (optionCopy: string, value: number) => {
    setSelectedValues({ ...selectedValues, [optionCopy]: value });
  };

  const handleTab = (key: any, optionCopy: string, value: number) => {
    if (key === 'Enter' || key === 'Spacebar' || key === ' ') {
      handleChange(optionCopy, value);
    }
  };

  const handleDis = () => {
    const scores = Object.values(selectedValues);
    const missingValue = scores.includes(null);
    setDisabled(missingValue);
  };

  const handleNext = (currentNumber: number, currentScore: number) => {
    const scoresTable = Object.values(selectedValues);
    let totalScoresTable = 0;
    scoresTable.forEach((value: any) => {
      totalScoresTable += value;
    });

    setCurrentQuestion((currentNumber += 1));
    setDisabled(true);
    setScore((currentScore += totalScoresTable));
  };

  return (
    <div className="leadership-assesssment__question-table bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
      <ProgressBar
        label={`${contents.questionNumber} of ${totalOfQuestions - 1}`}
        value={(contents.questionNumber - 1) / totalOfQuestions}
        max={1}
        className="leadership-assesssment__question-table-progress"
      />
      <h1 className="leadership-assesssment__question-table-title">{`${contents.questionNumber}. ${contents.title.props.defaultMessage}`}</h1>
      <h4 className="leadership-assesssment__question-table-subTitle">
        {contents.subTitle}
      </h4>
      <table className="leadership-assesssment__question-table-content bx--col-lg-16 bx--col-md-8">
        <thead className="leadership-assesssment__question-table-header">
          <tr className="leadership-assesssment__question-table-header-row">
            {headers?.map((header, i) => (
              <th
                key={header}
                id={'cell' + i}
                className="leadership-assesssment__question-table-header-unity"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="leadership-assesssment__question-table-body">
          {rows.map((row: any, rindex: number) => (
            <tr
              key={row.id}
              className="leadership-assesssment__question-table-body-row"
            >
              {Object.keys(row)
                .filter((key) => key !== 'id')
                .map((key, i) => {
                  return (
                    <td
                      key={key}
                      className="leadership-assesssment__question-table-cell"
                    >
                      {i < 1 ? (
                        row[key as keyof typeof row]
                      ) : (
                        <div className="leadership-assesssment__question-table-checkbox-container">
                          <input
                            tabIndex={i}
                            onKeyUp={(e: any) =>
                              handleTab(
                                e.key,
                                row[key as keyof typeof row].option,
                                row[key as keyof typeof row].value,
                              )
                            }
                            type="radio"
                            name={`option-${
                              row[key as keyof typeof row].option
                            }-${row[key as keyof typeof row].value}`}
                            aria-label={`${
                              row[key as keyof typeof row].option
                            } ${headers[i]}`}
                            className="leadership-assesssment__question-table-checkbox"
                            value={row[key as keyof typeof row].value}
                            checked={
                              row[key as keyof typeof row].value ===
                              selectedValues[
                                row[key as keyof typeof row].option
                              ]
                            }
                            onChange={() =>
                              handleChange(
                                row[key as keyof typeof row].option,
                                row[key as keyof typeof row].value,
                              )
                            }
                          />
                        </div>
                      )}
                    </td>
                  );
                })}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="leadership-assesssment__question-table-btn-container">
        <Button
          className="leadership-assesssment__question-table-btn"
          disabled={disabled}
          onClick={() => handleNext(currentQuestion, score)}
        >
          {qNextBtn}
          <ArrowRight20 />
        </Button>
      </div>
    </div>
  );
};

export default QuestionTable;
